import {ErrorCode} from '@sollapay/enums';
import {HttpClientError} from '@sollapay/http-client';

import type {BuyerDTO} from '@sollapay/types';

/**
 * An add-buyer response always echoes the buyers it added. An empty list means the add can't be
 * confirmed, so it must fail the mutation — surfacing through `saveError`, translated by its code
 * like any API error — rather than leave the form open with no feedback, inviting a resubmit.
 */
export function assertBuyersReturned(buyers: BuyerDTO[]): void {
  if (buyers.length === 0) {
    throw new HttpClientError(
      'The server did not confirm the added buyers',
      undefined,
      ErrorCode.BUYERS_NOT_CONFIRMED
    );
  }
}
